/*
 * Copyright (c) 2023. Legalbird eine Marke der R+S Internet Jewels GmbH
 */

import LegalBirdPageLoading from "../../ContentLoader/LegalBirdPageLoading";
import CaseNotFound from "../../Case/CaseNotFound/CaseNotFound";
import PageContentContainer from "../../Container/PageContentContainer";
import CaseFullForm from "../../Case/CaseForm/Full/CaseFullForm";
import NavigationExtensionAllData from "../../NavigationBar/NavigationExtensionAllData";
import { ProductHeadline } from "../../PageHeadline/PageHeadline";
import { useCase } from "../../../provider/CaseProvider";
import dayjs from "dayjs";

const CaseAllDataPage = () => {
  const { product, error, refreshCase } = useCase();

  if (!product) {
    return <LegalBirdPageLoading />;
  }

  if (error?.status === 404 || product?.customer?.isFake) {
    return <CaseNotFound />;
  }

  return (
    <>
      <NavigationExtensionAllData />
      <PageContentContainer size={"small"}>
        <ProductHeadline title="Alle Details zum Fall von" product={product} />
        <CaseFullForm product={product} refreshPage={refreshCase} />
      </PageContentContainer>
    </>
  );
};

export default CaseAllDataPage;
